var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Detail"},[_c('div'),_c('div'),_c('div',[_c('span',[_vm._v("Email: "),_c('i',[_vm._v("cs@ftmarketinginc.com")])])])])
}]

export { render, staticRenderFns }